import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faClose, faPlus, faHeading, faPenToSquare, faCheck, faTrash} from "@fortawesome/free-solid-svg-icons";
import {useAuth} from "../../providers/authprovider";
import useAlert from "../../components/CustomAlert";

export default function TodoModal(props){

    const [todos, setTodo] = useState(props.todos);
    const [expanded, setExpanded] = useState(-1);

    useEffect(()=>{
        if(todos === undefined)
            setTodo(props.todos);
    }, [props.todos])

    const handleExpand = (index)=>{
        if(expanded === index)
            return setExpanded(-1)

        setExpanded(index)
    }

    const handleTodoChange = (todo)=>{
        const existingIndex = todos.findIndex(c=>c.id === todo.id)

        if(existingIndex <0)
            return;

        todos.splice(existingIndex, 1, todo);
        setTodo([...todos]);
    }

    const handleDelete = (todo)=>{


        setTodo(prevState=>{
            const existingIndex = prevState.findIndex(c=>c.id === todo.id)

            if(existingIndex <0)
                return;

            prevState.splice(existingIndex, 1);

            return [...prevState];
        })
    }

    function sortTodos(a, b){
        const aDt = new Date(a.created_at).getTime();
        const bDt = new Date(b.created_at).getTime();

        return bDt - aDt;
    }

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            aria-labelledby="modal todo"
            dialogClassName="modal-80w"
        >
            <Modal.Header closeButton>
                <Modal.Title id="modal-todo">
                    Do zrobienia
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormCreateTodo onCreate={(todo)=>{setTodo([...todos, todo])}}/>
                {
                    todos?.sort(sortTodos).map((todo, index)=>
                        <TodoCard key={todo.id}  todo={todo} expanded={index === expanded} onChange={handleTodoChange} onDelete={handleDelete} onClick={()=>handleExpand(index)}/>
                    )
                }
            </Modal.Body>
        </Modal>
    )
}

function TodoCard(props){
    const {todo : {save, realize, remove}, user} = useAuth()
    const {showAlert, hideAlert, alert} = useAlert()
    const {todo, expanded, onChange, onDelete} = props;
    const [data, setData] = useState(todo);
    const [dirty, setDirty] = useState(false);

    useEffect(()=>{
        if(expanded)
            return;

        cancel()
    }, [expanded]);

    useEffect(()=>{
        setData(todo);
    }, [todo]);

    const handleChange = (e)=>{
        setData({...data, [e.target.name]:e.target.value})
        setDirty(true)
    }


    const handleOnClick = ()=>{
        if(expanded)
            return;

        props.onClick();
    }

    const handleClose = ()=>{
        cancel()
        props.onClick();
    }

    const cancel = ()=>{
        setData(todo)
        setDirty(false)
        hideAlert()
    }

    const saveChanges = ()=>{
        hideAlert();
        save(data, ({success, error, content})=>{
            if(success === true){
                onChange(content)
                setDirty(false)
                hideAlert();
                return;
            }
            showAlert(error)
        });
    }

    const setRealization = ()=>{
        if(!window.confirm("Potwierdź realizację"))
            return;

        hideAlert();
        realize(todo.id, ({success, error, content})=>{
            if(success === true){
                onChange(content)
                setDirty(false)
                hideAlert();
                return;
            }
            showAlert(error)
        })
    }

    const todoDate = new Date(todo.created_at).toLocaleDateString()
    const todoTime =  new Date(todo.created_at).toLocaleTimeString("pl-PL", {timeZone: "UTC"})

    const getRealizedBtn = ()=>{

        if(todo.user_realized_id === null)
            return  <Button disabled={dirty === true} variant={"success"} onClick={setRealization}><FontAwesomeIcon icon={faCheck} /> Wykonaj</Button>


        const realizedDate = new Date(todo.realized_time).toLocaleDateString()
        const realizedTime =  new Date(todo.realized_time).toLocaleTimeString("pl-PL", {timeZone: "UTC"})

        return  <Button disabled={true} variant={"success"} >
            <FontAwesomeIcon icon={faCheck} /> {todo.userName}
            <div>
                <small>{realizedTime} {realizedDate}</small>
            </div>
        </Button>

    }

    const handleDeleteTodo = ()=>{
        if(!window.confirm("Potwierdź usunięcie notatki."))
            return;

        hideAlert();
        remove(todo.id, ({success, error, content})=>{
            if(success === true){
                onDelete(content)
                hideAlert();
                return;
            }
            showAlert(error)
        })
    }

    const deleteBtn = user.isAdmin ? <Button variant={"danger"} onClick={handleDeleteTodo} ><FontAwesomeIcon icon={faTrash}/> Usuń</Button> : <></>;

    return (
        <Card className={"cursor-pointer mb-2 hovered-card"} onClick={handleOnClick}>
            {alert()}
            <Card.Body>
                <small className={"position-absolute"} style={{right:"4px", top:"2px"}}>{todoTime} {todoDate}</small>
                {
                    expanded ?
                    <div >
                        <FontAwesomeIcon icon={faHeading} />
                        <Form.Control
                            className={"ms-2 todoInput todoTitle"}
                            value={data.title}
                            type={"text"}
                            name={"title"}
                            onChange={handleChange}
                        ></Form.Control>
                        <FontAwesomeIcon icon={faPenToSquare} />
                        <Form.Control
                            className={"ms-2 mb-2 todoInput"}
                            value={data.todo}
                            type={"text"}
                            name={"todo"}
                            as={"textarea"}
                            rows={4}
                            onChange={handleChange}
                            placeholder={"Opis zadania "}
                        ></Form.Control>
                        <div className={"space-between"}>
                            <div>
                                <Button disabled={dirty === false} onClick={saveChanges} className={"me-2"} variant={"primary"}>Zapisz zmiany</Button>
                                <Button variant={"outline-secondary"} onClick={handleClose}><FontAwesomeIcon icon={faClose} /></Button>
                            </div>
                            {getRealizedBtn()}
                            {deleteBtn}
                        </div>
                    </div>
                        :
                     <span className={""}>{todo.title}</span>
                }
            </Card.Body>
        </Card>
    )
}

function FormCreateTodo(props){

    const {todo} = useAuth();
    const [edition, setEdition] = useState(false);
    const [title, setTitle] = useState("");
    const {alert, showAlert, hideAlert} = useAlert();


    const handleSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();

        if(title.length <=0)
            return;

        todo.create(title, ({success, error, content})=>{

           if(success === false) {
               showAlert(error)
               return;
           }

           hideAlert()

            setEdition(false);
            setTitle("");

            props.onCreate(content)

        });

    }


    return (
        <div className={"mb-2"}>
            {
                edition ?
                    <Form onSubmit={handleSubmit}>
                        {
                            alert()
                        }
                       <Form.Control
                            type={"text"}
                            as={"textarea"}
                            placeholder={"Wprowadź tytuł zadania"}
                            value={title}
                            onChange={(e)=>setTitle(e.target.value)}
                            className={"mb-2"} >
                        </Form.Control>
                        <div>
                            <Button variant={"primary"} className={"me-2"} type={"submit"}> Dodaj zadanie</Button>
                            <Button variant={"outline-secondary"} type={"button"} onClick={()=>setEdition(false)}><FontAwesomeIcon icon={faClose}/></Button>
                        </div>
                    </Form>
                :
                    <Button variant={"outline-secondary"} className={"border-0 w-100"} onClick={()=>setEdition(true)}><FontAwesomeIcon icon={faPlus}/>  Dodaj zadanie</Button>
            }

        </div>


    )
}